
import React, { Component } from 'react';
import { CardFooter, Modal, ModalHeader, ModalFooter, Progress, Badge, Table, Spinner, Button, Collapse, Card, CardBody, CardHeader, Col, Row, FormGroup, Input, Label } from 'reactstrap';
import { AppSwitch } from '@coreui/react'
import authHeaders from '../../authHeaders.js';
import '../../gstart-console.css';
import ExportDeviceSettings from './ExportDeviceSettings.js';
import Popup from "reactjs-popup";
import Loader from '../Loader.js';
import ConsoleHelper from '../../ConsoleHelper.js';
import DateOps from '../DateOps.js';


class ExportDeviceDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      farm_id: "",
      IsDeviceLoaded: true,
      anchoraccordion: [true, false, false, false], // this is length of device_details array
      detailsLoadingIndex: null, // index of the device whose dashboard is currently loading (lazy load on expand)
      selectedIndex: null, // redesign: which device's modal is open (null = grid view)
      copiedMac: null, // shows "Copied" feedback on the box whose MAC was just copied
      isButtonLoading: false,

      errorMessageToast: '',
      isOpenToast: false,
      issuccess: false,

      isLoadingOpenCloseValve: false,
      isOpenCloseValve: false,

      isLoadingAutomation: false,
      isOpenCloseAutomation: false,

      duration: "",

      isLoadingMessageHsitoryDetails: false,
      displayMessage: '',

      modal: false,


      sub_details: [],

      isShowSpinner: false,

      device_id: "",
      device_name: "",
      displayErrorMessageForDeviceID: "",

      isDownloading: false,
      downloadStatus: "",
      isLoading: false,

      lblExplblmsg018: 'No Data Found',
      lblExplblmsg019: "gStart",
      lblExplblmsg020: "Device Sync Pending - Save settings once device comes online and wait for 20 seconds",
      lblExplblmsg021: "Show History",
      lblExplblmsg022: "Valve",
      lblExplblmsg023: "Start",
      lblExplblmsg024: "Stop",
      lblExplblmsg025: "Valve 1",
      lblExplblmsg026: "Running",
      lblExplblmsg027: "Idle",
      lblExplblmsg028: "Valve 2",
      lblExplblmsg029: "Valve 3",
      lblExplblmsg030: "Valve 4",
      lblExplblmsg031: "Valve 5",
      lblExplblmsg032: "Valve 6",
      lblExplblmsg033: "Pump"
    }
    this.mqttClient = null;
  }

  fetchMessageHistoryDetails = (exp_device_mac_id) => {
    this.setState({ isLoadingMessageHsitoryDetails: true, displayMessage: "" })

    var sentData = {
      method: 'GET',
      headers: authHeaders()
    };

    fetch(process.env.REACT_APP_URL + "/fm_export_timeline?&uid=" + this.props.uid + "&exp_device_mac_id=" + exp_device_mac_id, sentData)
      .then(response => response.json())
      .then(details => {
        ConsoleHelper("details message history...." + JSON.stringify(details));
        this.setState({ messageHistoryDetails: details, isLoadingMessageHsitoryDetails: false, })
        if (details.length === 0 || details === null) {
          this.setState({ displayMessage: this.state.lblExplblmsg018 })
        }
      })
  }






  componentDidMount = () => {
    this.setState({
      farm_id: this.props.selected_farm.farm_id,
      IsDeviceLoaded: true,
    })
    this.fetchDeviceDetails(this.props.selected_farm.farm_id);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.selected_farm === null || this.props.selected_farm === undefined) {
      return;
    }
    if (prevProps.selected_farm.farm_id !== this.props.selected_farm.farm_id) {

      this.setState({
        farm_id: this.props.selected_farm.farm_id,
        IsDeviceLoaded: true
      });
      this.fetchDeviceDetails(this.props.selected_farm.farm_id);
    }

  }

  handleDurationChange = (event, exp_device_mac_id) => {
    const value = parseFloat(event.target.value) || 0;
    this.setState((prevState) => {
      const updatedDevices = [...prevState.devices];

      // Find the device that matches exp_device_mac_id
      const deviceIndex = updatedDevices.findIndex(
        (device) => device.exp_device_mac_id === exp_device_mac_id
      );

      if (deviceIndex !== -1) {
        // Update the duration for the matched device
        updatedDevices[deviceIndex].details[0].duration = value * 60;
        updatedDevices[deviceIndex].details[0].duration_minute = value;
      }

      return { devices: updatedDevices }; // Update the state with modified devices
    });
  };


  handleStopClick = (e, exp_device_mac_id) => {
    const { devices } = this.state;
    this.setState({
      isShowSpinner: true,
    });

    // Find the device that matches exp_device_mac_id
    const device = devices.find(
      (device) => device.exp_device_mac_id === exp_device_mac_id
    );

    if (device) {
      fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/send_config_export", {
        method: "POST", body: JSON.stringify({
          config: {
            cmd: 101
          },
          exp_device_mac_id: device.exp_device_mac_id,
          uid: this.props.uid,
        })
      })
        .then(res => res.json())
        .then(details => {
          this.fetchValveStatusOff(this, 1, device.exp_device_mac_id);
        });
    }
  };

  handleStartClick = (e, exp_device_mac_id) => {
    const { devices } = this.state;
    this.setState({
      isShowSpinner: true,
    });

    // Find the device that matches exp_device_mac_id
    const device = devices.find(
      (device) => device.exp_device_mac_id === exp_device_mac_id
    );

    if (device) {
      // Perform start operation for the matched device
      const activeValves = [];
      var on_msg = "";
      var off_msg = "";
      for (let i = 1; i <= 6; i++) {
        if (device.details[0][`valve${i}`] === 1) {
          activeValves.push(i);
          on_msg = on_msg + "|R-" + ((i * 2) - 1);
          off_msg = off_msg + "|R-" + (i * 2);
        }
      }

      on_msg = on_msg.replace("|", "");
      off_msg = off_msg.replace("|", "");


      if (activeValves.length === 0) {
        alert(`No valves are active for device ${exp_device_mac_id}.`);
      } else {


        fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/send_config_export", {
          method: "POST", body: JSON.stringify({
            config: {
              cmd: 103,
              on_cmd: on_msg,
              duration: device.details[0].duration,
              off_cmd: off_msg,
            },
            exp_device_mac_id: device.exp_device_mac_id,
            uid: this.props.uid,
          })
        })
          .then(res => res.json())
          .then(details => {

            this.fetchValveStatusNew(this, 1, device.exp_device_mac_id);
          });






        // Add your logic for starting valves here, e.g., API call or state update
      }
    }
  };


  handleValveToggle = (index, exp_device_mac_id) => {
    this.setState((prevState) => {
      const updatedDevices = [...prevState.devices]; // Clone the devices array

      // Find the device matching the exp_device_mac_id
      const deviceIndex = updatedDevices.findIndex(
        (device) => device.exp_device_mac_id === exp_device_mac_id
      );

      if (deviceIndex !== -1) {
        // Toggle the specific valve for the matching device
        updatedDevices[deviceIndex].details[0][`valve${index + 1}`] =
          updatedDevices[deviceIndex].details[0][`valve${index + 1}`] == 1 ? 0 : 1;

        return { devices: updatedDevices }; // Update state with modified devices array
      }

      return null; // No changes if the device is not found
    });
  };



  fetchDeviceDetails = (localDataFarmId) => {
    if (!this.props.uid) {
      return;
    }
    this.setState({
      IsDeviceLoaded: true,
    });

    let sentData = {
      method: 'GET',
      headers: authHeaders(),
    };

    // Load the device LIST only (config). Per-device dashboard data is loaded LAZILY
    // when a tile is expanded (toggleAnchorAccordion -> loadDeviceDashboard), instead of
    // fetching every device's dashboard up front.
    fetch(
      `${process.env.REACT_APP_URL}/fm_export_device_config?uid=${this.props.uid}`,//&farm_id=${localDataFarmId}
      sentData
    )
      .then((res) => res.json())
      .then((details) => {
        // Guard: on an auth/error response the API returns an object, not an array.
        const list = Array.isArray(details) ? details : [];
        const filteredDetails = list.filter(
          (device) => device.exp_device_type === 53 || device.exp_device_type === 72
        );
        // No dashboard details yet -> null; filled in when the tile is expanded.
        filteredDetails.forEach((d) => { d.details = null; });

        this.setState({
          devices: filteredDetails,
          anchoraccordion: Array(filteredDetails.length).fill(false), // all tiles collapsed
          IsDeviceLoaded: false, // list loaded
        });
      })
      .catch((error) => {
        // Handle errors from the initial config fetch
        console.error("Error fetching device config:", error);
        this.setState({ IsError: true });
      });

  };

  // Lazily fetch one device's dashboard data (called when its tile is expanded).
  loadDeviceDashboard = (index) => {
    const device = this.state.devices[index];
    if (!device || device.details) {
      return; // nothing to load, or already loaded (cached)
    }
    this.setState({ detailsLoadingIndex: index });

    const sentData = { method: 'GET', headers: authHeaders() };
    fetch(
      `${process.env.REACT_APP_URL}/fm_export_device_dashboard?uid=${this.props.uid}&exp_device_mac_id=${device.exp_device_mac_id}&exp_device_type=${device.exp_device_type}`,
      sentData
    )
      .then((res) => res.json())
      .then((dtl) => {
        this.setState((prevState) => {
          const devices = prevState.devices.slice();
          devices[index] = { ...devices[index], details: dtl };
          return { devices, detailsLoadingIndex: null };
        });
      })
      .catch((error) => {
        console.error("Error fetching device dashboard:", error);
        this.setState({ detailsLoadingIndex: null });
      });
  };




  updateDeviceData = (macId, mqttData) => {
    // Split the incoming MQTT message (string) by '|'
    const details = mqttData.split("|");

    if (details.length !== 12) {
      console.error("Invalid MQTT data format.");
      return; // Ensure we have all 12 expected values
    }

    // Prepare the update object to update the device's details[0] fields
    const updatedDetails = {
      volt1: parseFloat(details[0]),
      volt2: parseFloat(details[1]),
      volt3: parseFloat(details[2]),
      amps: parseFloat(details[3]),
      units: details[4],
      v1: parseFloat(details[5]),
      v2: parseFloat(details[6]),
      v3: parseFloat(details[7]),
      v4: parseFloat(details[8]),
      v5: parseFloat(details[9]),
      v6: parseFloat(details[10]),
      automation: details[11],
    };

    // Update the state with the new data for the device with the matching macId
    this.setState((prevState) => {
      const updatedDevices = prevState.devices.map((device) => {
        if (device.exp_device_mac_id === macId) {
          return {
            ...device, // Spread the existing device data
            details: [
              {
                ...device.details[0], // Spread the existing details object
                ...updatedDetails, // Merge the updated details object
              },
            ],
          };
        }
        return device; // Leave other devices unchanged
      });
      //console.log("changed")
      return { devices: updatedDevices }; // Update state with the modified devices array
    });
  };






  toggleAnchorAccordion = (tab) => {
    this.setState(prevState => {
      const anchoraccordion = prevState.anchoraccordion.map((x, index) => tab === index ? !x : false);
      return { anchoraccordion };
    }, () => {
      // When a tile becomes open and its dashboard isn't loaded yet, fetch it lazily.
      if (this.state.anchoraccordion[tab] && this.state.devices[tab] && !this.state.devices[tab].details) {
        this.loadDeviceDashboard(tab);
      }
    });
  }

  // ---- Redesign (presentation only): grid box -> modal. Reuses the existing detail
  // render (renderDevicesAnchorDetails) and the existing lazy-load, no logic removed. ----
  openDevice = (index) => {
    this.setState(prevState => ({
      selectedIndex: index,
      anchoraccordion: prevState.anchoraccordion.map((_, i) => i === index), // keep this device's detail expanded
    }), () => {
      if (this.state.devices[index] && !this.state.devices[index].details) {
        this.loadDeviceDashboard(index);
      }
    });
  }

  closeDevice = () => { this.setState({ selectedIndex: null }); }

  copyMac = (mac, e) => {
    if (e) e.stopPropagation(); // don't open the device modal
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(mac);
      } else {
        const ta = document.createElement('textarea');
        ta.value = mac; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
    } catch (err) { /* clipboard may be blocked; ignore */ }
    this.setState({ copiedMac: mac });
    clearTimeout(this._copyTimer);
    this._copyTimer = setTimeout(() => this.setState({ copiedMac: null }), 1500);
  }

  renderDeviceBox = (data, index) => {
    if (!(data.exp_device_type === 53 || data.exp_device_type === 72)) { return null; }
    const synced = data.is_sync == null ? null : !!data.is_sync;
    return (
      <div className="gs-box" key={"gsbox-" + index} tabIndex={0} role="button"
        onClick={() => this.openDevice(index)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.openDevice(index); } }}>
        <div className="gs-box-top">
          <div className="gs-devicon" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 7h8M8 11h8M8 15h4" /></svg>
          </div>
          <div className="gs-box-pills">
            {synced === null ? null : (synced
              ? <span className="gs-pill synced">Synced</span>
              : <span className="gs-pill nosync"><span className="gs-dot"></span>Not synced</span>)}
          </div>
        </div>
        <div className="gs-name">{data.device_name || 'Device'}</div>
        <div className="gs-mac">
          <span className="gs-mac-text">{data.exp_device_mac_id}</span>
          <button className="gs-copy" type="button" title="Copy MAC" aria-label="Copy MAC address"
            onClick={(e) => this.copyMac(data.exp_device_mac_id, e)}>
            {this.state.copiedMac === data.exp_device_mac_id
              ? <span className="gs-copied">Copied</span>
              : <i className="fa fa-copy"></i>}
          </button>
        </div>
        <div className="gs-glance">
          <span className="gs-metric" style={{ color: 'var(--gs-faint)' }}>Tap to open live data &amp; settings</span>
        </div>
      </div>
    );
  }

  onCancelButtonClick = () => {
    this.setState({
      isOpenCloseValve: false,
      isLoadingOpenCloseValve: false,
      valve: "",
    })
  }

  onCancelButtonAutomationClick = () => {
    this.setState({
      isOpenCloseAutomation: false,
      isLoadingAutomation: false,
      sel_exp_device_mac_id: ""
    })
  }


  onClickOnOffToggle(valve, event) {
    //event.persist();
    this.setState({
      isLoadingOpenCloseValve: true,
      isOpenCloseValve: true,
      valve: valve
      //data.details[0].v1: event.target.checked ? 0 : 1
    })
  }

  onClickOnOffToggleAutomation = (sel_exp_device_mac_id) => {
    //console.log(sel_exp_device_mac_id);
    //event.persist();
    this.setState({
      isLoadingAutomation: true,
      isOpenCloseAutomation: true,
      sel_exp_device_mac_id: sel_exp_device_mac_id
      //data.details[0].v1: event.target.checked ? 0 : 1
    })
  }

  onOkButtonClickAutomation = (data, event) => {

    const { sel_exp_device_mac_id } = this.state;
    const selectedDevice = this.state.devices.find(device => device.exp_device_mac_id === sel_exp_device_mac_id);
    if (selectedDevice) {
      var msg = selectedDevice.details[0].automation === 0 ? 102 : 105;
      var msg_no = selectedDevice.details[0].automation === 0 ? 1 : 0;
      if (msg) {
        this.setState({
          isShowSpinner: true
        })
        fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/send_config_export", {
          method: "POST",
          body: JSON.stringify({
            config: { cmd: msg },
            exp_device_mac_id: selectedDevice.exp_device_mac_id,
            uid: this.props.uid,
          })
        })
          .then(res => res.json())
          .then(details => {
            // After sending the configuration, call the valve status API three times
            this.fetchAutomationStatus(this, 1, selectedDevice.exp_device_mac_id, msg_no, this.state.farm_id);
          })
          .catch(error => {
            console.error('Error sending configuration:', error);
            this.setState({
              isShowSpinner: false
            });
          });

      }
    }



    // Function to fetch valve status

  }



  fetchAutomationStatus = (e, callNumber, exp_device_mac_id, msg_no, farm_id) => {
    fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/export_auto_status?exp_device_mac_id=" + exp_device_mac_id)
      .then(res => res.json())
      .then(valveDetails => {
        //////console.log(valveDetails)
        if (valveDetails.length > 0) {

          if (valveDetails[0]?.hasOwnProperty("automation") && valveDetails[0].automation == msg_no) {
            e.setState({
              isShowSpinner: false
            });
            //alert("ok")
            //////console.log(e.state.devices);
            var devices = e.state.devices;
            //////console.log("automation:"+msg_no)
            for (var i in devices) {
              if (devices[i].exp_device_mac_id == exp_device_mac_id) {
                devices[i].details[0].automation = msg_no
                devices[i].details[0].v1 = 0;
                devices[i].details[0].v2 = 0;
                devices[i].details[0].v3 = 0;
                devices[i].details[0].v4 = 0;
                devices[i].details[0].v5 = 0;
                devices[i].details[0].v6 = 0;
                devices[i].details[0].amp = 0;
              }
            }
            //////console.log(devices);
            e.setState({
              devices: devices,
              sel_exp_device_mac_id: ""
            })
            //e.fetchDeviceDetails(farm_id);
            return; // Stop further API calls
          }
          else if (callNumber == 10) {
            alert("The device is not reachable at the moment. Please try again later.");
          }
        }
        ////console.log('Valve status call', callNumber, ':', valveDetails);
        // Schedule the next API call if it's not the third call
        if (callNumber < 10) {
          setTimeout(() => {
            this.fetchAutomationStatus(e, callNumber + 1, exp_device_mac_id, msg_no, farm_id);
          }, 1000);
        } else {
          // Update component state to hide the spinner after all API calls are completed
          e.setState({
            isShowSpinner: false,
            sel_exp_device_mac_id: ""
          });
        }
      })
      .catch(error => {
        // Handle errors from the valve status API call
        console.error('Error fetching valve status:', error);

        // Update component state to hide the spinner
        this.setState({
          isShowSpinner: false
        });
      });
  }

  onModalClick = () => {
    this.setState({ isOpenCloseValve: !this.state.isOpenCloseValve })
  }

  onModalClickAutomation = () => {
    this.setState({ isOpenCloseAutomation: !this.state.isOpenCloseAutomation })
  }


  fetchValveStatusOff = (e, callNumber, exp_device_mac_id) => {
    fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/valve_status?exp_device_mac_id=" + exp_device_mac_id)
      .then(res => res.json())
      .then(valveDetails => {
        if (valveDetails.length > 0) {
          if (valveDetails[0]?.hasOwnProperty("v1")) {

            if (valveDetails[0].v1 === 0 && valveDetails[0].v2 === 0 && valveDetails[0].v3 === 0 && valveDetails[0].v4 === 0 && valveDetails[0].v5 === 0 && valveDetails[0].v6 === 0) {
              e.setState({
                isShowSpinner: false
              });
              var devices = e.state.devices;
              for (var i in devices) {
                if (devices[i].exp_device_mac_id == exp_device_mac_id) {
                  devices[i].details[0].v1 = valveDetails[0].v1;
                  devices[i].details[0].v2 = valveDetails[0].v2;
                  devices[i].details[0].v3 = valveDetails[0].v3;
                  devices[i].details[0].v4 = valveDetails[0].v4;
                  devices[i].details[0].v5 = valveDetails[0].v5;
                  devices[i].details[0].v6 = valveDetails[0].v6;
                }
              }
              e.setState({
                devices: devices,
              })
              return;
            }
            else if (callNumber == 10) {
              alert("The device is not reachable at the moment. Please try again later.");
            }

          }
          else if (callNumber == 10) {
            alert("The device is not reachable at the moment. Please try again later.");
          }

        }
        if (callNumber < 10) {
          setTimeout(() => {
            this.fetchValveStatusOff(e, callNumber + 1, exp_device_mac_id);
          }, 1000);
        } else {
          e.setState({
            isShowSpinner: false,
          });
        }
      })
      .catch(error => {
        console.error('Error fetching valve status:', error);

        this.setState({
          isShowSpinner: false
        });
      });
  }


  fetchValveStatusNew = (e, callNumber, exp_device_mac_id) => {
    fetch(process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/valve_status?exp_device_mac_id=" + exp_device_mac_id)
      .then(res => res.json())
      .then(valveDetails => {
        if (valveDetails.length > 0) {
          if (valveDetails[0]?.hasOwnProperty("v1")) {

            if (valveDetails[0].v1 === 1 || valveDetails[0].v2 === 1 || valveDetails[0].v3 === 1 || valveDetails[0].v4 === 1 || valveDetails[0].v5 === 1 || valveDetails[0].v6 === 1) {
              e.setState({
                isShowSpinner: false
              });
              var devices = e.state.devices;
              for (var i in devices) {
                if (devices[i].exp_device_mac_id == exp_device_mac_id) {
                  devices[i].details[0].v1 = valveDetails[0].v1;
                  devices[i].details[0].v2 = valveDetails[0].v2;
                  devices[i].details[0].v3 = valveDetails[0].v3;
                  devices[i].details[0].v4 = valveDetails[0].v4;
                  devices[i].details[0].v5 = valveDetails[0].v5;
                  devices[i].details[0].v6 = valveDetails[0].v6;
                }
              }
              e.setState({
                devices: devices,
              })
              return;
            }
            else if (callNumber == 10) {
              alert("The device is not reachable at the moment. Please try again later.");
            }

          }
          else if (callNumber == 10) {
            alert("The device is not reachable at the moment. Please try again later.");
          }

        }
        if (callNumber < 10) {
          setTimeout(() => {
            this.fetchValveStatusNew(e, callNumber + 1, exp_device_mac_id);
          }, 1000);
        } else {
          e.setState({
            isShowSpinner: false,
          });
        }
      })
      .catch(error => {
        console.error('Error fetching valve status:', error);

        this.setState({
          isShowSpinner: false
        });
      });
  }





  selectModal = (info) => {
    this.setState({ modal: !this.state.modal }) // true/false toggle
  }




  renderDevicesAnchorDetails = (data, index) => {


    const { duration, startMessage } = this.state;

    // ////console.log(data)
    // ////console.log(index)
    // if(index==0){
    //   return null;
    // }

    //////console.log(data);
    if (data.exp_device_type === 53 || data.exp_device_type === 72) {
      return (
        <Card className="mb-0" key={"heading_12_" + index}>
          <CardHeader id={"heading_top_" + index}>
            <Button block color="link" className="text-left m-0 p-0" onClick={() => this.toggleAnchorAccordion(index)} aria-expanded={this.state.anchoraccordion[index]} aria-controls={"collapse" + index}>
              <i className="fa fa-caret-square-o-right"></i>
              &nbsp;&nbsp;
              <strong>{data.device_name} : {data.exp_device_mac_id}</strong>
              {" - "}{data.user_name
                ? data.user_name
                : data.user_email
                  ? data.user_email
                  : data.user_mobile}






            </Button>
            {data.is_sync == null ? "" : data.is_sync ? "" :
              <div style={{ color: 'red' }}>
                {this.state.lblExplblmsg020}
              </div>
            }



          </CardHeader>
          <Collapse isOpen={this.state.anchoraccordion[index]} data-parent="#anchoraccordion" id={"collapse" + index} aria-labelledby={"heading" + index}>
            <CardBody>
              {data.details && data.details.length > 0 ? (
                <React.Fragment>

              <Row>
                <Col>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* Popup-triggering div */}
                    <div
                      className="messageHistoryDetailsDiv"
                      onClick={(e) => e.stopPropagation()} // Prevent click events from propagating
                      style={{ marginRight: '10px' }} // Add some margin between the elements
                    >
                      <a
                        onClick={async (e) => {
                          e.stopPropagation(); // Stop event from bubbling up to the parent div
                          await this.fetchMessageHistoryDetails(data.exp_device_mac_id); // Ensure data fetch
                          this.setState({ popupVisible: true }); // Trigger popup visibility
                        }}
                        style={{ cursor: "pointer", color: "red" }}
                      >
                        <i className="fa fa-list-alt"></i>
                      </a>

                      <Popup
                        open={this.state.popupVisible}
                        onClose={() => this.setState({ popupVisible: false })}
                        closeOnDocumentClick={false}
                      >
                        <CardBody style={{ maxHeight: "400px", overflowY: "auto" }}>
                          {/* Close Button */}
                          <div align="left"
                            //style={{ marginTop: "5px", width: "80%" }}
                            style={{
                              position: "absolute", // Fix it to the top right
                              top: "5px",           // Distance from the top
                              left: "5px",         // Distance from the right
                              zIndex: 9999,         // Ensure the button is above other content
                            }}

                          >
                            <button
                              onClick={() => this.setState({ popupVisible: false })}
                              style={{
                                padding: "5px 10px",
                                backgroundColor: "#20a8d8",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                            >
                              X
                            </button>
                          </div>
                          <Table hover bordered striped responsive size="sm">
                            <thead>
                              <tr align="center">
                                <th>{this.state.lblExplblmsg022}</th>
                                <th>{this.state.lblExplblmsg023}</th>
                                <th>{this.state.lblExplblmsg024}</th>
                                <th>Duration</th>
                              </tr>
                            </thead>
                            {this.state.isLoadingMessageHsitoryDetails ? (
                              <Loader code={"info"} />
                            ) : (
                              <tbody>
                                {this.state.messageHistoryDetails?.map((messagehistory, i) => {
                                  let duration = "-"; // Default value for duration
                                  let kWh = "";
                                  if (messagehistory.is_reset == 1) {
                                    duration = "Stop time unknown";
                                  }
                                  else if (messagehistory.start_time && messagehistory.stop_time) {
                                    const startTime = new Date(messagehistory.start_time);
                                    const stopTime = new Date(messagehistory.stop_time);

                                    if (!isNaN(startTime) && !isNaN(stopTime)) {
                                      const diffMs = stopTime - startTime;

                                      const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                                      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                                      duration = `${hours} hrs : ${minutes} mins : ${seconds} sec`;

                                      if (messagehistory.units) {
                                        kWh = messagehistory.units
                                      }
                                    } else {
                                      duration = "Invalid date";
                                    }
                                  } else if (messagehistory.start_time && !messagehistory.stop_time) {
                                    duration = "In Progress";
                                  } else if (!messagehistory.start_time && messagehistory.stop_time) {
                                    duration = "Start time missing";
                                  } else {
                                    duration = "No data available";
                                  }

                                  return (
                                    <tr key={"messageHistory" + i}>
                                      <td>{messagehistory.details}</td>
                                      <td>
                                        {messagehistory.start_time ? (
                                          <DateOps
                                            date_={new Date(messagehistory.start_time)}
                                            type_="TIME"
                                            localTimeZone={data.details[0].timezone}
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {messagehistory.stop_time && messagehistory.is_reset == 0 ? (
                                          <DateOps
                                            date_={new Date(messagehistory.stop_time)}
                                            type_="TIME"
                                            localTimeZone={data.details[0].timezone}
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td><>{duration}{kWh ? <>{" - "}<span style={{ fontWeight: "bold", color: "green" }}>{kWh} kWh</span></> : null}</> </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            )}
                          </Table>
                          <div align="center">
                            {this.state.displayMessage ? this.state.displayMessage : ""}
                          </div>
                        </CardBody>
                      </Popup>
                    </div>

                    {/* Refresh or Loader Element */}
                    {!this.state.IsDeviceLoaded ? (
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={(e) => this.fetchDeviceDetails(this.state.farm_id)}
                        className="float-right"
                      >
                        <i className="icon-refresh"></i>
                      </a>
                    ) : (
                      <a className="float-right">
                        <Loader type={"small"} />
                      </a>
                    )}
                  </div>


                </Col>
                <Col>
                  {/* {////console.log(data.details)} */}
                  {this.state.isShowSpinner === false ? (
                    <>
                      <AppSwitch
                        id={`maintauto-${data.exp_device_mac_id}`}
                        className="float-right"
                        variant="3d"
                        color="success"
                        onChange={() => this.onClickOnOffToggleAutomation(data.exp_device_mac_id)}
                        checked={data.details[0].automation === 1}
                      />
                    </>
                  ) : (
                    <>
                      {this.state.sel_exp_device_mac_id == data.exp_device_mac_id ? (
                        <div className="float-right">
                          <Spinner size="sm"></Spinner>
                        </div>
                      ) : (
                        <AppSwitch
                          id={`maintauto-${data.exp_device_mac_id}`}
                          disabled
                          className="float-right"
                          variant="3d"
                          color="success"
                          checked={data.details[0].automation === 1}
                        />
                      )}
                    </>
                  )}




                  <Modal isOpen={this.state.isOpenCloseAutomation} onClick={this.onModalClickAutomation} >
                    <ModalHeader>{
                      "Are you sure want to [0] Automation?"
                        .replace('[0]', data.details[0].automation === 0 ? "ON" : "OFF")
                    } </ModalHeader>
                    <ModalFooter>
                      <Button color="primary" onClick={this.onOkButtonClickAutomation.bind(this, data)}>Ok</Button>{' '}
                      <Button color="secondary" onClick={this.onCancelButtonAutomationClick}>Cancel</Button>
                    </ModalFooter>
                  </Modal>

                </Col>
              </Row>
              <Row><Col><span className="float-right text-muted small">{data.details[0].automation === 1 ? "Automation On" : "In Manual Mode"} </span></Col></Row>


              <Card className={"gs-valves " + (data.details[0].v1 == 1 || data.details[0].v2 == 1 || data.details[0].v3 == 1 || data.details[0].v4 == 1 || data.details[0].v5 == 1 || data.details[0].v6 == 1 ? "border-success" : "border-secondary")} key={"faviwmap1-" + index}>
                <CardHeader>
                  Valves
                  <div className="card-header-actions">
                    <Badge color={data.details[0].v1 == 1 || data.details[0].v2 == 1 || data.details[0].v3 == 1 || data.details[0].v4 == 1 || data.details[0].v5 == 1 || data.details[0].v6 == 1 ? "success" : "secondary"} className="float-right">
                      {data.details[0].v1 == 1 || data.details[0].v2 == 1 || data.details[0].v3 == 1 || data.details[0].v4 == 1 || data.details[0].v5 == 1 || data.details[0].v6 == 1 ? this.state.lblExplblmsg026 : this.state.lblExplblmsg027}
                    </Badge>
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    {
                      Array.from({ length: 6 }, (_, index1) => (
                        <Col md="12" key={index1}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                            {/* Valve Image with Number Overlay */}
                            <div style={{ position: "relative", marginRight: "10px", width: "70px", height: "70px" }}>
                              {
                                data.details[0][`v${index1 + 1}`] === 1 ? (
                                  <img src="./valve/valve-on.png" width="70px" height="70px" alt={`Valve ${index1 + 1} On`} />
                                ) : (
                                  <img src="./valve/valve-off.png" width="70px" height="70px" alt={`Valve ${index1 + 1} Off`} />
                                )
                              }
                              <div style={{
                                position: "absolute",
                                top: "73%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}>
                                {index1 + 1}
                              </div>
                            </div>

                            {/* Switch */}
                            <AppSwitch
                              id={`valve${index1 + 1}Id`}
                              disabled={
                                (data.details[0].automation === 0) &&
                                  data.details[0].v1 == 0 &&
                                  data.details[0].v2 == 0 &&
                                  data.details[0].v3 == 0 &&
                                  data.details[0].v4 == 0 &&
                                  data.details[0].v5 == 0 &&
                                  data.details[0].v6 == 0

                                  ? false : true}
                              className={'float-right'}
                              variant={'3d'}
                              color={'success'}
                              checked={(data.details[0][`valve${index1 + 1}`] === 1 || data.details[0][`v${index1 + 1}`] === 1)}
                              onChange={() => this.handleValveToggle(index1, data.exp_device_mac_id)}
                            />
                          </div>
                        </Col>
                      ))
                    }
                  </Row>
                  {data.details[0].automation === 0 ?
                    <>
                      <Row>
                        <Col md="3">
                          <FormGroup>
                            <Label>Duration in Minutes</Label>
                            <Input
                              type="number"
                              className="form-control"
                              disabled={data.details[0].automation == 0 ? false : true}
                              placeholder="Enter Minutes"
                              value={this.state.devices.find(device => device.exp_device_mac_id === data.exp_device_mac_id)?.details[0].duration_minute || ''}
                              onChange={(event) => this.handleDurationChange(event, data.exp_device_mac_id)} // Pass exp_device_mac_id
                            />

                          </FormGroup>

                        </Col>
                      </Row>
                      <Row>
                        <Col md="3" className="d-flex justify-content-center">
                          <Button
                            color="success"
                            onClick={(event) => this.handleStartClick(event, data.exp_device_mac_id)}
                            disabled={data.details[0].automation == 1 ||
                              this.state.isShowSpinner ||
                              data.details[0].v1 === 1 ||
                              data.details[0].v2 === 1 ||
                              data.details[0].v3 === 1 ||
                              data.details[0].v4 === 1 ||
                              data.details[0].v5 === 1 ||
                              data.details[0].v6 === 1
                            }
                          >{this.state.isShowSpinner ? <Spinner size="sm"></Spinner> : ""}
                            Start
                          </Button>
                          &nbsp;&nbsp;
                          {
                            data.details[0].automation === 0 && (
                              data.details[0].v1 === 1 ||
                              data.details[0].v2 === 1 ||
                              data.details[0].v3 === 1 ||
                              data.details[0].v4 === 1 ||
                              data.details[0].v5 === 1 ||
                              data.details[0].v6 === 1) ?
                              <>
                                <Button
                                  color="danger"
                                  onClick={(event) => this.handleStopClick(event, data.exp_device_mac_id)}

                                >{this.state.isShowSpinner ? <Spinner size="sm"></Spinner> : ""}
                                  Stop
                                </Button>
                              </>
                              : null
                          }



                        </Col>

                      </Row>
                    </>
                    : null}


                </CardBody>
              </Card>










              <Row>

                <br />
                <Col md="12">
                  {

                    data.details[0].amp !== null ?
                      <Card className={"gs-pump " + ((data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ? "border-success" : "border-secondary")} key={"faviM2_1_" + index}>
                        <CardHeader>
                          {this.state.lblExplblmsg033}
                          <div className="card-header-actions">
                            <Badge color={(data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ? "success" : "secondary"} className="float-right">
                              {(data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ? this.state.lblExplblmsg026 : this.state.lblExplblmsg027}
                            </Badge>
                          </div>
                        </CardHeader>
                        <CardBody>
                          <Row>
                            <Col md="6">
                              <div style={{ textAlign: "center" }}>
                                {(data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ?
                                  <img src="./motor/pump-running.png" width="200px"></img>
                                  : <img src="./motor/pump-idle.png" width="200px"></img>}
                              </div>

                            </Col>
                            <Col md="6">

                              <div className={(data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ? "callout callout-success" : "callout callout-secondary"}>
                                <strong className="h4">Energy Stats</strong>
                              </div>


                              <div className="progress-group">
                                <div className="progress-group-header">
                                  <i className="icon-calendar progress-group-icon"></i>
                                  <span className="title">Voltage 1</span>

                                  {/* Apply conditional classes */}
                                  <span
                                    className={`ml-auto font-weight-bold ${data.details &&
                                      data.details[0] &&
                                      typeof data.details[0].volt1 !== "undefined" &&
                                      data.config &&
                                      data.config.settings &&
                                      data.config.settings.sensing &&
                                      Array.isArray(data.config.settings.sensing) &&
                                      data.config.settings.sensing.length > 0 &&
                                      (data.details[0].volt1 < data.config.settings.sensing[0].l ||
                                        data.details[0].volt1 > data.config.settings.sensing[0].h)
                                      ? data.details[0].volt1 > data.config.settings.sensing[0].h
                                        ? "blinking high-voltage" // High voltage
                                        : "blinking power-cut"    // Power cut
                                      : ""
                                      }`}
                                  >
                                    {data.details && data.details[0] && typeof data.details[0].volt1 !== "undefined"
                                      ? data.details[0].volt1
                                      : "N/A"}
                                  </span>
                                </div>
                                <div className="progress-group-bars">
                                  <Progress
                                    className="progress-xs"
                                    color={
                                      data.details &&
                                        data.details[0] &&
                                        typeof data.details[0].volt1 !== "undefined" &&
                                        data.details[0].v1 +
                                        data.details[0].v2 +
                                        data.details[0].v3 +
                                        data.details[0].v4 +
                                        data.details[0].v5 +
                                        data.details[0].v6 >
                                        0
                                        ? "success"
                                        : "secondary"
                                    }
                                    value="100"
                                  />
                                </div>
                              </div>


                              <div className="progress-group">
                                <div className="progress-group-header">
                                  <i className="icon-calendar progress-group-icon"></i>
                                  <span className="title">Voltage 2</span>

                                  {/* Apply conditional classes */}
                                  <span
                                    className={`ml-auto font-weight-bold ${data.details &&
                                      data.details[0] &&
                                      typeof data.details[0].volt2 !== "undefined" &&
                                      data.config &&
                                      data.config.settings &&
                                      data.config.settings.sensing &&
                                      Array.isArray(data.config.settings.sensing) &&
                                      data.config.settings.sensing.length > 1 &&
                                      (data.details[0].volt2 < data.config.settings.sensing[1].l ||
                                        data.details[0].volt2 > data.config.settings.sensing[1].h)
                                      ? data.details[0].volt2 > data.config.settings.sensing[1].h
                                        ? "blinking high-voltage" // High voltage
                                        : "blinking power-cut"    // Power cut
                                      : ""
                                      }`}
                                  >
                                    {data.details && data.details[0] && typeof data.details[0].volt2 !== "undefined"
                                      ? data.details[0].volt2
                                      : "N/A"}
                                  </span>
                                </div>
                                <div className="progress-group-bars">
                                  <Progress
                                    className="progress-xs"
                                    color={
                                      data.details &&
                                        data.details[0] &&
                                        typeof data.details[0].volt2 !== "undefined" &&
                                        data.details[0].v1 +
                                        data.details[0].v2 +
                                        data.details[0].v3 +
                                        data.details[0].v4 +
                                        data.details[0].v5 +
                                        data.details[0].v6 >
                                        0
                                        ? "success"
                                        : "secondary"
                                    }
                                    value="100"
                                  />
                                </div>
                              </div>





                              <div className="progress-group">
                                <div className="progress-group-header">
                                  <i className="icon-calendar progress-group-icon"></i>
                                  <span className="title">Voltage 3</span>

                                  {/* Apply conditional classes */}
                                  <span
                                    className={`ml-auto font-weight-bold ${data.details &&
                                      data.details[0] &&
                                      typeof data.details[0].volt3 !== "undefined" &&
                                      data.config &&
                                      data.config.settings &&
                                      data.config.settings.sensing &&
                                      Array.isArray(data.config.settings.sensing) &&
                                      data.config.settings.sensing.length > 1 &&
                                      (data.details[0].volt3 < data.config.settings.sensing[2].l ||
                                        data.details[0].volt3 > data.config.settings.sensing[2].h)
                                      ? data.details[0].volt3 > data.config.settings.sensing[2].h
                                        ? "blinking high-voltage" // High voltage
                                        : "blinking power-cut"    // Power cut
                                      : ""
                                      }`}
                                  >
                                    {data.details && data.details[0] && typeof data.details[0].volt3 !== "undefined"
                                      ? data.details[0].volt3
                                      : "N/A"}
                                  </span>
                                </div>
                                <div className="progress-group-bars">
                                  <Progress
                                    className="progress-xs"
                                    color={
                                      data.details &&
                                        data.details[0] &&
                                        typeof data.details[0].volt3 !== "undefined" &&
                                        data.details[0].v1 +
                                        data.details[0].v2 +
                                        data.details[0].v3 +
                                        data.details[0].v4 +
                                        data.details[0].v5 +
                                        data.details[0].v6 >
                                        0
                                        ? "success"
                                        : "secondary"
                                    }
                                    value="100"
                                  />
                                </div>
                              </div>





                              <div className="progress-group" >
                                <div className="progress-group-header">
                                  <i className="icon-calendar progress-group-icon"></i>
                                  <span className="title">Current in Amps</span>
                                  <span className="ml-auto font-weight-bold">{data.details[0].amp}</span>
                                </div>
                                <div className="progress-group-bars">
                                  <Progress className="progress-xs" color={(data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ? "success" : "secondary"} value="100" />
                                </div>
                              </div>

                              <div className="progress-group" >
                                <div className="progress-group-header">
                                  <i className="icon-calendar progress-group-icon"></i>
                                  <span className="title">Units Consumed</span>
                                  <span className="ml-auto font-weight-bold">{data.details[0].units}</span>
                                </div>
                                <div className="progress-group-bars">
                                  <Progress className="progress-xs" color={(data.details[0].v1 + data.details[0].v2 + data.details[0].v3 + data.details[0].v4 + data.details[0].v5 + data.details[0].v6) > 0 ? "success" : "secondary"} value="100" />
                                </div>
                              </div>
                              <div style={{ textAlign: 'right' }}>
                                <small>Updated on {<DateOps date_={new Date(data.details[0].data_sync_on)} type_="TIME" localTimeZone={data.details[0].timezone} />}</small>
                              </div>

                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                      : null
                  }
                </Col>





              </Row>

              <div style={{ textAlign: 'right' }}>
                <small>Version: {data.details ? data.details[0].fw_version : "-"}</small>
                {data.details &&
                  data.details[0].fw_version.replace("VER-", "") !==
                  data.details[0].fw_version_new.replace("VER-", "") && (
                    <div style={{ marginTop: '4px' }}>
                      <span style={{ display: 'block', color: '#d9534f', fontWeight: 'bold' }}>
                        New Version released
                      </span>
                      <Button
                        color="info"
                        style={{ marginTop: '4px' }}
                        onClick={() => this.handleDownload(data.details[0].fw_version_new, data.details[0].exp_device_mac_id)}
                        disabled={this.state.isDownloading}
                      >
                        <i className="cui-cloud-download" style={{ marginRight: '8px' }}></i>
                        {this.state.isDownloading ? <Spinner size="sm" /> : 'Download'}
                      </Button>
                      {this.state.downloadStatus && (
                        <div
                          style={{
                            marginTop: '8px',
                            color: this.state.isDownloading
                              ? 'blue'
                              : this.state.downloadStatus.includes('Failed')
                                ? 'red'
                                : 'green',
                          }}
                        >
                          {this.state.downloadStatus}
                        </div>
                      )}
                    </div>
                  )}
              </div>






                </React.Fragment>
              ) : (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>
                  {!data.details ? (
                    <React.Fragment><Spinner size="sm" /> &nbsp;Loading device data…</React.Fragment>
                  ) : (
                    "No data available for this device."
                  )}
                </div>
              )}
              {this.state.anchoraccordion[index] && (
                <div style={{ marginTop: '1rem', borderTop: '1px solid #e6e6e6', paddingTop: '0.75rem' }}>
                  <ExportDeviceSettings
                    embeddedDevice={data}
                    uid={this.props.uid}
                    selected_farm={this.props.selected_farm}
                  />
                </div>
              )}
            </CardBody>
          </Collapse>
        </Card>
      );
    }

    return null; // Handle other cases here if necessary
  }

  handleAddCard = () => {
    this.setState({ popupVisible1: true })
  }

  handleDeviceID = (e) => {
    const deviceID = e.target.value;
    let errorMessage = '';

    // Example: Validation logic for alphanumeric input
    const isValidAlphanumeric = /^[a-zA-Z0-9]*$/.test(deviceID); // Accept only letters and numbers
    if (!isValidAlphanumeric) {
      errorMessage = 'Device ID must be alphanumeric.';
    } else if (deviceID.length > 12) {
      errorMessage = 'Device ID cannot exceed 12 characters.';
    }

    this.setState({
      device_id: deviceID,
      displayErrorMessageForDeviceID: errorMessage,
    });
  };


  handleDeviceName = (e) => {
    const deviceName = e.target.value;
    let errorMessage = '';

    // Example: Validation logic for alphanumeric input
    const isValidAlphanumeric = /^[a-zA-Z0-9]*$/.test(deviceName); // Accept only letters and numbers
    if (!isValidAlphanumeric) {
      errorMessage = 'Device Name must be alphanumeric.';
    } else if (deviceName.length > 20) {
      errorMessage = 'Device Name cannot exceed 20 characters.';
    }

    this.setState({
      device_name: deviceName,
      displayErrorMessageForDeviceName: errorMessage,
    });
  };

  handleDownload = async (version, exp_device_mac_id) => {
    this.setState({ isDownloading: true, downloadStatus: "" }); // Reset and start downloading

    const baseUrl = process.env.REACT_APP_URL_NODE.replace("/on_off_device", "");
    const downloadUrl = `${baseUrl}/download_firmware`;
    const checkUrl = `${baseUrl}/check_firmware?exp_device_mac_id=${exp_device_mac_id}`;

    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      // 1. Call the initial API to start the download process
      const downloadResponse = await fetch(downloadUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          exp_device_mac_id: exp_device_mac_id,
          uid: this.props.uid,
        }),
      });

      if (!downloadResponse.ok) {
        throw new Error("Failed to start download");
      }

      // 2. Start polling the server every 5 seconds to check for version update
      const intervalId = setInterval(async () => {
        try {
          const checkResponse = await fetch(checkUrl, { method: 'GET', headers });

          if (!checkResponse.ok) {
            clearInterval(intervalId); // Stop polling if there's an error
            this.setState({ downloadStatus: "Failed to check version on the server" });
            this.setState({ isDownloading: false }); // Stop the spinner
            return;
          }

          const checkData = await checkResponse.json();

          // Check if the version is updated on the server

          if (checkData.length > 0) {
            if (checkData[0].is_firmware_downloaded === 1) {
              // Success: Version is updated
              clearInterval(intervalId);
              this.setState({ downloadStatus: "Success! Version updated." });
              this.setState({ isDownloading: false }); // Stop the spinner
            }
          }
          else {
            clearInterval(intervalId); // Stop polling if there's an error in the polling request
            this.setState({ downloadStatus: "Error while checking firmware status." });
            this.setState({ isDownloading: false }); // Stop the spinner

            setTimeout(() => {
              window.location.reload();  // This will reload the page
            }, 5000);
          }
        } catch (error) {
          clearInterval(intervalId); // Stop polling if there's an error in the polling request
          this.setState({ downloadStatus: "Error while checking firmware status." });
          this.setState({ isDownloading: false }); // Stop the spinner

          setTimeout(() => {
            window.location.reload();  // This will reload the page
          }, 5000);
        }
      }, 20000); // Poll every 10 seconds

      // 3. If the version isn't updated in 5 minute, show failure
      setTimeout(() => {
        clearInterval(intervalId); // Stop polling after 1 minute
        this.setState({ downloadStatus: "Failed: Version update not completed in time." });
        this.setState({ isDownloading: false }); // Stop the spinner
      }, 300000); // 1 minute timeout

    } catch (error) {
      // Handle errors from the initial API call
      this.setState({
        downloadStatus: `Download failed: ${error.message}. Please try again later.`,
        isDownloading: false, // Stop the spinner on error
      });
    }
  };




  btnSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission if applicable

    this.setState({
      isButtonLoading: true,
    });

    const { device_id, device_name } = this.state;

    try {
      // Make the POST request

      var url = process.env.REACT_APP_URL_NODE.replace("/on_off_device", "") + "/add_device";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          device_id: device_id,
          device_name: device_name,
          uid: this.props.uid
        }),
      });
      const result = await response.json();

      if (result.code == 200) {
        alert("Device saved successfully!");
        setTimeout(() => {
          this.setState({
            popupVisible1: false,
            device_name: "",
            device_id: "",
            isButtonLoading: false
          });
        }, 1500);
        setTimeout(() => {
          window.location.reload();  // This will reload the page
        }, 5000);
      } else {
        alert("Failed to save device: " + (result.message || "Unknown error"));
        this.setState({
          isButtonLoading: false, // Allow retry
        });
      }
    } catch (error) {
      this.setState({
        isButtonLoading: false, // Allow retry
      });
    }
  };


  render() {
    const buttonStyle = {
      marginBottom: "20px",
    };
    return (
      <>


        {/* {!this.state.IsDeviceLoaded && */}
        <div id="deviceanchor1" className="gs-console">
          <div className="gs-cards">
            {this.state.devices && this.state.devices.map((data, index) =>
              this.renderDeviceBox(data, index)
            )}
          </div>

          {this.state.selectedIndex !== null && this.state.devices[this.state.selectedIndex] && (
            <div className="gs-overlay" onClick={this.closeDevice}>
              <div className="gs-modal" onClick={(e) => e.stopPropagation()}>
                <button className="gs-modal-close" onClick={this.closeDevice} aria-label="Close">&times;</button>
                <div id="anchoraccordion">
                  {this.renderDevicesAnchorDetails(this.state.devices[this.state.selectedIndex], this.state.selectedIndex)}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* } */}

        <br />
        <div className="animated fadeIn">
          {this.state.IsDeviceLoaded && this.props.uid ? <Loader code="info" /> :
            <button className="btn btn-primary" style={buttonStyle} onClick={this.handleAddCard}>
              + Add Device
            </button>
          }
        </div>

        <div className="messageHistoryDetailsDiv">
          <Popup
            open={this.state.popupVisible1}
            onClose={() => this.setState({ popupVisible1: false })}
          >
            <CardBody
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Close Button */}
              <button
                onClick={() => this.setState({ popupVisible1: false })}
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#20a8d8",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginBottom: "20px",
                }}
              >
                Close
              </button>

              {/* Device ID Input */}
              <Row style={{ justifyContent: "center", width: "100%" }}>
                <Col md="6" style={{ textAlign: "center" }}>
                  <FormGroup>
                    <Label htmlFor="nf-1">Device ID</Label>
                    <Input
                      type="text"
                      maxLength="12"
                      id="nf-device-id"
                      name="nf-device-id"
                      placeholder="Device ID"
                      onChange={this.handleDeviceID}
                      value={this.state.device_id}
                    />
                    <div style={{ color: "red", marginTop: 4 }}>
                      {this.state.displayErrorMessageForDeviceID}
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              {/* Device Name Input */}
              <Row style={{ justifyContent: "center", width: "100%" }}>
                <Col md="6" style={{ textAlign: "center" }}>
                  <FormGroup>
                    <Label htmlFor="nf-1">Device Name</Label>
                    <Input
                      type="text"
                      maxLength="30"
                      id="nf-device-name"
                      name="nf-device-name"
                      placeholder="Device Name"
                      onChange={this.handleDeviceName}
                      value={this.state.device_name}
                    />
                  </FormGroup>
                </Col>
              </Row>


              {/* Save Button */}
              {this.state.device_id && this.state.device_name ? (
                <Button
                  color="success"
                  block
                  onClick={this.btnSubmit}
                  disabled={this.state.isButtonLoading}
                  style={{
                    width: "200px",
                    textAlign: "center",
                    marginTop: "10px",
                    padding: "10px 15px",
                  }}
                >
                  <i className="fa icon-check"></i>&nbsp;&nbsp;Save&nbsp;&nbsp;
                  {this.state.isButtonLoading ? <Spinner size="sm" /> : ""}
                </Button>
              ) : null}
            </CardBody>
          </Popup>
        </div>


      </>
    )
  }
}

export default ExportDeviceDashboard;
